// Laatst getoonde stand en tijdstip, zodat useSaleEvents na een herstart van de Pi kan inhalen wat er gemist is.

const storageKey = "td-last-seen";

// scope is de maand ("9-2026"): een stand van een andere maand telt niet, de teller begint dan op nul.
export function readLastSeen(scope) {
  try {
    const raw = window.localStorage.getItem(storageKey);
    if (!raw) return null;
    const record = JSON.parse(raw);
    return record?.scope === scope && typeof record.at === "number" ? record : null;
  } catch {
    // Privémodus of volle opslag: dan gaat het zonder inhalen.
    return null;
  }
}

export function writeLastSeen(record) {
  try {
    window.localStorage.setItem(storageKey, JSON.stringify(record));
  } catch {
    /* mag het dashboard niet ophouden */
  }
}

// Alleen de tijd bijstellen naar het moment dat het beeld wegviel (zie screenAwake.js), de cijfers blijven.
export function touchLastSeen(scope, at) {
  const record = readLastSeen(scope);
  if (!record || typeof at !== "number") return;
  writeLastSeen({ ...record, at });
}
